import cx from "classnames";
import React from "react";

import "./MessageShell.css";

export interface MessageShellProps {
  children: React.ReactNode;
  alignment: "left" | "right";
  disableAnimations?: boolean;
}

/**
 * MessageShell provides the outer layout wrapper for chat messages.
 * Handles alignment, spacing, and optional animations for message bubbles.
 */
export const MessageShell = ({
  children,
  alignment,
  disableAnimations = false,
}: MessageShellProps) => {
  const containerClassName = cx("flex items-start gap-2", {
    "flex-row-reverse": alignment === "right",
  });

  if (disableAnimations) {
    // Static wrapper for historical messages - no animations
    return <div className={containerClassName}>{children}</div>;
  }

  // Animated wrapper for streaming messages (CSS keyframes)
  return (
    <div className={cx(containerClassName, "message-fade-scale-in")}>
      {children}
    </div>
  );
};
